function addToCart(variantId, addToCartBtn) {
    console.log("Adding variant ID:", variantId); // Check the variant ID

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id: variantId,
            quantity: 1
        }),
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.json();
    })
    .then(data => {
        console.log("Product added successfully:", data);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
                product: data,
                addToCartBtn: addToCartBtn
            }
        }));
    })
    .catch(error => {
    console.error("Error adding product to cart:", error);
    console.log("Response Status:", status);
    console.log("Response Text:", xhr.responseText);
    if (xhr.responseJSON) {
        console.log("Parsed Error:", xhr.responseJSON);
    }
    });
}




document.addEventListener('DOMContentLoaded', (event) => {
    const countdownElement = document.querySelector('.morders-countdown');
    let countdownValue = Math.floor(Math.random() * (100 - 20 + 1)) + 20;
  if(countdownElement){
    countdownElement.textContent = countdownValue;
    function decreaseCountdown() {
        if (countdownValue > 0) {
            countdownValue--;
            countdownElement.textContent = countdownValue;
            countdownElement.classList.add('mfade');
            setTimeout(() => {
                countdownElement.classList.remove('mfade');
            }, 500);
        }
    }
    setInterval(decreaseCountdown, 5000);
    }
});

function videoBlockSlider() { 
  $('.M-video-block-slider').slick({
    infinite: false,
    speed: 400,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
      responsive: [ 
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });
}

function videoSliderSection() {
    $('.M-video-slideshow').slick({
    infinite: true,
    speed: 400,
    autoplay: true,
    slidesToShow: 3,
    pauseOnHover: true,
    slidesToScroll: 1,
    arrows: false,
    autoplaySpeed: 5000,
    dots: false,
      responsive: [ 
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
}






/* custom js for bundle */

subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    updateVariantID(event.data.variant.id);
});

function updateVariantID(variantId)
{
  $('.activeForm[data-type="add-to-cart-form"] input[name="id"]').val(variantId);
}

function makeFormActive(formId)
{
  $('[data-type="add-to-cart-form"]').removeClass('activeForm');
  $(formId).addClass('activeForm');

  updateImages();
}

function updateImages()
{
  
  /* updating all images */
  $('.bundleLabelItem .selectAndImageHolder').each(function(index) {
    var valueHere = $(this).find('select').val();
    var imageWeWant = $('variant-radios img[data-selector="'+valueHere+'"]').attr('src');
    $(this).find('.imageHolder img').attr('src',imageWeWant);
  });
  
}

updateImages();

function purchaseBundle()
{
 $('button.bundleBTN').addClass('loading'); 


  var items = []; 
  $('input:checked+label .bundle-item:not(.clickBtnHere)').each(function(index) {
      var valueHere = $(this).find('input[name="id"]').val();
      var data = {quantity:1,id:parseInt(valueHere)}
      items.push(data); 
  });
   
    $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {items},
    dataType: 'json', 
    success: function (data) { 
    // now clicklast item button and update cart properly.
      $('input:checked+label .bundle-item.clickBtnHere button.quick-add__submit').click();

       $('button.bundleBTN').removeClass('loading'); 
     } 
   }); 
}
  $('.cstm-announcement').slick({
    infinite: true,
    speed: 300,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,

  });
function initQuotesSlider() {
  var swiper = new Swiper(".MQuotesSwiper", {
    loop: true,
    slidesPerView: 1,
    centeredSlides: false,
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 2.3,
        centeredSlides: true,
        spaceBetween: 80,
      },
    },
    navigation: {
      nextEl: ".m-quotes-swiper-arrow-right",
      prevEl: ".m-quotes-swiper-arrow-left",
    },
  });
}
function initMPostsSlider() {
  var swiper = new Swiper(".MPostsSwiper", {
    slidesPerView: 4,
    spaceBetween: 5,
    breakpoints: {
      768: {
        spaceBetween: 15,
      },
    },    
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".mpopup-modal").forEach((modal) => {
        modal.addEventListener("click", function () {
            document.querySelector(".mpopup-container-wrapper")?.classList.add("mpopup_opened");
            document.body.classList.add("mpopup_opened");
            document.querySelector(".shopify-section-group-header-group")?.classList.add("mpopup_opened");
        });
    });

    document.querySelector(".mpopup-container-wrapper")?.addEventListener("click", function (event) {
        if (!event.target.closest(".mpopup-container")) {
            this.classList.remove("mpopup_opened");
            document.body.classList.remove("mpopup_opened");
            document.querySelector(".shopify-section-group-header-group")?.classList.remove("mpopup_opened");
        }
    });
});


